import { IParseConfiguration } from '@app/data/services';
import { version } from '../../package.json';
import { PLATFORM_URLS, platformUrl } from '@w3booster/platform-config';
export const environment = {
  env: 'PROD',
  production: true,
  REST_URL: platformUrl(PLATFORM_URLS.api),
  GIFT_URL: platformUrl(PLATFORM_URLS.website, '/gift/'),
  PARSE: {
    URL: platformUrl(PLATFORM_URLS.api, '/parse'),
    APP_ID: 'PSBdEx46ycVok7grEcdOMKPMsLYUl1OZ',
    JS_KEY: 'stnDsBFS854z78FSBFu36bscjxhbv'
  } as IParseConfiguration,
  LIVESERVER_URL: PLATFORM_URLS.realtime,
  version: version
};
